<template>
	<v-modal>
		<template v-slot:header>
			<h1>Qualify Lead</h1>
		</template>
		<p v-if="!outcome" class="beta center">Please confirm you intend to qualify this lead as genuine.</p>
		<OutcomeBadge
			v-else
			:result="true"
			class="center" message="Lead qualified"/>
		<template v-slot:footer>
			<ul class="actions">
				<template v-if="!outcome">
					<li>
						<button
							:disabled="qualifying" class="button button--secondary" @click.prevent="close">Cancel
						</button>
					</li>
					<li>
						<process-button
							:processing="qualifying" class="button button--primary" text="Qualify Lead"
							@click="instruct"/>
					</li>
				</template>
				<li v-else>
					<button
						:disabled="qualifying" class="button button--secondary" @click.prevent="close">Close
					</button>
				</li>
			</ul>
		</template>
	</v-modal>
</template>
<script>
import OutcomeBadge from "../../../../../../common/components/OutcomeBadge.vue";

export default {
	components: {
		OutcomeBadge,
	},

	data() {
		return {
			qualifying: false,
			outcome: null,
		};
	},

	props: {
		lead: {
			required: true,
			type: Object,
		},
		success: {
			required: true,
			type: Function,
		},
	},

	methods: {
		close() {
			this.$vmodal.close();
		},
		instruct() {
			this.qualifying = true;
			http().patch(this.route("leads/:lead/qualify", this.lead)).then(response => {
				this.$store.commit("clients/LEAD_UPDATED", response.data.data);
				this.qualifying = false;
				this.outcome = true;
				this.success();
			});
		},
	},
};
</script>
